import React, { useEffect, useState } from 'react';
import {
  Button,
  Space,
  DatePicker,
  Table,
  Alert,
  ConfigProvider,
  Select,
  message,
  Input,
  Radio,
} from 'antd';
import { EmptyFileColor } from 'patternx-svg';
import type { DatePickerProps } from 'antd/es/date-picker';
import type { RadioChangeEvent } from 'antd';
import moment from 'moment';
import 'moment/locale/zh-cn';
import PtxEmpty from '@/components/ptx-empty';
import {
  getOpenBizType,
  getOpenClientType,
  getOpenFileType,
  downoadOpenApi,
  getOpenSlaTableInfo,
  getOpenSlaStatisticInfo,
  downoadRenderApi,
  getRenderTableInfo,
  getRenderStatisticInfo,
} from '@/services/initial';
import './index.less';
import { getRenderStatus } from '@/utils/utils';

moment.locale('zh-cn');

type searchParams = {
  startTime: string;
  endTime: string;
  resolutions: string[];
  status: number;
  itemName: string;
  itemId: string;
  modelId: string;
  orderByField: string;
  orderByValue: string;
};

const Render: React.FC<{}> = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [param, setParam] = useState<searchParams>({} as searchParams);
  const [data, setData] = useState<any>();
  const [fileInfo, setFileInfo] = useState({
    totalAvgCost: 0,
    totalMaxCost: 0,
    totalMinCost: 0,
    failedCnt: 0,
    totalRecord: 0,
    failedRatio: '',
  });
  const [resolutions, setResolutions] = useState<any[]>([]);
  const [status, setStatus] = useState<any[]>([]);
  const [itemName, setItemName] = useState<any>(undefined);
  const [itemId, setItemId] = useState<any>(undefined);
  const [modelId, setModelId] = useState<any>(undefined);
  const [single, setSingle] = useState<boolean | undefined>();
  const [page, setPage] = useState<number>(1); // 当前页码
  const [size, setSize] = useState<number>(10); // 每页显示数据数量
  const [total, setTotal] = useState<number>(0); // 总共数据量

  const columns: any = [
    {
      title: '序号',
      dataIndex: 'index',
      key: 'index',
      render: (text: any, record: any, index: number) => (
        <div style={{ width: 50 }}>{index + 1}</div>
      ),
    },
    {
      title: '渲染任务id',
      dataIndex: 'id',
      key: 'id',
      render: (text: any) => <div style={{ width: 160 }}>{text}</div>,
    },
    {
      title: '渲染开始时间',
      dataIndex: 'startRenderingTime',
      key: 'startRenderingTime',
      render: (text: any) => <div style={{ width: 160 }}>{text}</div>,
    },
    {
      title: '渲染结束时间',
      dataIndex: 'finishRenderingTime',
      key: 'finishRenderingTime',
      render: (text: any) => <div style={{ width: 160 }}>{text || '-'}</div>,
    },
    {
      title: '任务总耗时(秒)',
      dataIndex: 'taskTotalCost',
      key: 'taskTotalCost',
      render: (text: any) => <div style={{ width: 160 }}>{text || '-'}</div>,
    },
    {
      title: '渲染方案id',
      dataIndex: 'itemId',
      key: 'itemId',
      render: (text: any) => <div style={{ width: 160 }}>{text || '-'}</div>,
    },
    {
      title: '渲染方案名称',
      dataIndex: 'itemName',
      key: 'itemName',
      render: (text: any) => <div style={{ width: 160 }}>{text || '-'}</div>,
    },
    {
      title: '全景图id',
      dataIndex: 'sceneId',
      key: 'sceneId',
      render: (text: any) => <div style={{ width: 100 }}>{text || '-'}</div>,
    },
    {
      title: '全景图名称',
      dataIndex: 'sceneName',
      key: 'sceneName',
      render: (text: any) => <div style={{ width: 100 }}>{text || '-'}</div>,
    },
    {
      title: '模型id',
      dataIndex: 'modelId',
      key: 'modelId',
      render: (text: any) => <div style={{ width: 200 }}>{text || '-'}</div>,
    },
    {
      title: '分辨率',
      dataIndex: 'resolution',
      key: 'resolution',
      render: (text: any) => <div style={{ width: 60 }}>{text || '-'}</div>,
    },
    {
      title: '渲染图状态',
      dataIndex: 'status',
      key: 'status',
      render: (text: any, record: any) => <div style={{ width: 60 }}>{getRenderStatus(record.status) || '-'}</div>,
    },
    {
      title: '渲染图状态描述',
      dataIndex: 'statusName',
      key: 'statusName',
      render: (text: any) => <div style={{ width: 160 }}>{text || '-'}</div>,
    },
    {
      title: '渲染图消息记录',
      dataIndex: 'msg',
      key: 'msg',
      render: (text: any) => <div style={{ width: 160 }}>{text || '-'}</div>,
    },
    {
      title: '企业id',
      dataIndex: 'enterpriseId',
      key: 'enterpriseId',
      render: (text: any) => <div style={{ width: 160 }}>{text || '-'}</div>,
    },
  ];

  const renderEmpty = () => {
    return <PtxEmpty isEmpty={true} describe="暂无数据" icon={<EmptyFileColor />} />;
  };

  // 获取table数据
  const getDatas = async (params?: any) => {
    setIsLoading(true);
    const res = await getRenderTableInfo({
      startTime: params?.startTime === '' ? '' : params?.startTime || param?.startTime,
      endTime: params?.endTime === '' ? '' : params?.endTime || param?.endTime,
      resolutions: params?.resolutions || param?.resolutions,
      status: params?.status || param?.status,
      itemName: params?.itemName || param?.itemName,
      itemId: params?.itemId || param?.itemId,
      modelId: params?.modelId || param?.modelId,
      orderByField: params?.orderByField || param?.orderByField,
      orderByValue: params?.orderByValue || param?.orderByValue,
      // single: params?.single === true || params?.single === false ? params?.single : param?.single,
      pageIndex: page,
      pageSize: size,
    });
    setIsLoading(false);
    if (res?.success && res?.data?.details) {
      if (res.data.details.current > res.data.details.pages) {
        // 当前页数超过实际可请求到的页数时的处理
        const resOnceMore = await getRenderTableInfo({
          startTime: params?.startTime === '' ? '' : params?.startTime || param?.startTime,
          endTime: params?.endTime === '' ? '' : params?.endTime || param?.endTime,
          resolutions: params?.resolutions || param?.resolutions,
          status: params?.status || param?.status,
          itemName: params?.itemName || param?.itemName,
          itemId: params?.itemId || param?.itemId,
          modelId: params?.modelId || param?.modelId,
          pageIndex: res.data.details.pages,
          orderByField: params?.orderByField || param?.orderByField,
          orderByValue: params?.orderByValue || param?.orderByValue,
          pageSize: size,
        });
        const datas = resOnceMore?.data?.details.records;
        setData(datas);
        setTotal(resOnceMore.data.details.total || 0);
        setPage(resOnceMore.data.details.current || 1);
        setSize(resOnceMore.data.details.size || 10);
        console.log('getOpeningDatas', res, resOnceMore);
      } else {
      const datas = res?.data?.details.records;
      setData(datas);
      setTotal(res.data.details.total || 0);
      setPage(res.data.details.current || 1);
      setSize(res.data.details.size || 10);
      }
    }
  };

  const getSlaOpenStatistics = async (params?: any) => {
    const res = await getRenderStatisticInfo({
      startTime: params?.startTime === '' ? '' : params?.startTime || param?.startTime,
      endTime: params?.endTime === '' ? '' : params?.endTime || param?.endTime,
      resolutions: params?.resolutions || param?.resolutions,
      status: params?.status || param?.status,
      itemName: params?.itemName || param?.itemName,
      itemId: params?.itemId || param?.itemId,
      modelId: params?.modelId || param?.modelId,
      orderByField: params?.orderByField || param?.orderByField,
      orderByValue: params?.orderByValue || param?.orderByValue,
    });
    console.log('getOpenSlaStatisticInfo', res);
    if (res.success) {
      const details = res?.data?.details;
      setFileInfo({
        totalAvgCost: details?.totalAvgCost,
        totalMinCost: details?.totalMinCost,
        totalMaxCost: details?.totalMaxCost,
        failedCnt: details?.failedCnt,
        totalRecord: details?.totalRecord,
        failedRatio: details?.failedRatio,
      });
    }
  };

  // 获取分辨率选项列表
  const getBizType = async () => {
    const data = ['2K', '4K', '8K', '16K']
    setResolutions(
      data.map((d: string) => {
        return {
          label: d,
          value: d,
        };
      }),
    );
  };

  // 获取终端选项列表
  const getClientType = async () => {
    const data = ['新建', '排队中', '渲染中', '完成', '失败', '取消', '错误']
    setStatus(
      data.map((d: string, i: number) => {
        return {
          label: d,
          value: i,
        };
      }),
    );
  };

  // 初始化
  const init = () => {
    getDatas(); // 获取table数据
    getBizType(); // 获取业务线选项列表
    getClientType(); // 获取终端选项列表
    getSlaOpenStatistics(); // 获取sla打开的统计数据
  };

  // 搜索-时间范围-起始时间
  const onChange1 = (value: DatePickerProps['value']) => {
    const startTime = value?.format('YYYY-MM-DD HH:mm:ss') || '';
    console.log(startTime, 'onChange1');
    setParam({
      ...param,
      startTime,
    });
    getDatas({
      ...param,
      startTime,
    });
    getSlaOpenStatistics({
      ...param,
      startTime,
    });
  };

  // 搜索-时间范围-截止时间
  const onChange2 = (value: DatePickerProps['value']) => {
    const endTime = value?.format('YYYY-MM-DD HH:mm:ss') || '';
    setParam({
      ...param,
      endTime,
    });
    getDatas({
      ...param,
      endTime,
    });
    getSlaOpenStatistics({
      ...param,
      endTime,
    });
  };

  // 搜索-业务线
  const handleChange1 = (value: string[]) => {
    setParam({
      ...param,
      resolutions: value,
    });
    getDatas({
      resolutions: value,
    });
    getSlaOpenStatistics({
      resolutions: value,
    });
  };

  // 搜索-终端类型
  const handleChange2 = (value: string) => {
    setParam({
      ...param,
      status: +value,
    });
    getDatas({
      status: value,
    });
    getSlaOpenStatistics({
      status: value,
    });
  };

  // 搜索-文件名称
  const handleItemNameChange = (e: any) => {
    const value = e.target.value;
    if (value) {
      setItemName(value);
    } else {
      setItemName(undefined);
      getDatas({
        // 搜索框内容全部删除时，重置table数据
        itemName: '',
      });
      getSlaOpenStatistics({
        itemName: '',
      });
    }
    setParam({
      ...param,
      itemName: value,
    });
  };

  const handleModelIdChange = (e: any) => {
    const value = e.target.value;
    if (value) {
      setModelId(value);
    } else {
      setModelId(undefined);
      getDatas({
        // 搜索框内容全部删除时，重置table数据
        modelId: '',
      });
      getSlaOpenStatistics({
        modelId: '',
      });
    }
    setParam({
      ...param,
      modelId: value,
    });
  };

  const handleItemIdChange = (e: any) => {
    const value = e.target.value;
    if (value) {
      setItemId(value);
    } else {
      setItemId(undefined);
      getDatas({
        // 搜索框内容全部删除时，重置table数据
        itemId: '',
      });
      getSlaOpenStatistics({
        itemId: '',
      });
    }
    setParam({
      ...param,
      itemId: value,
    });
  };

  // 搜索-确认搜索
  const onSearch = () => {
    getDatas();
    getSlaOpenStatistics();
  };

  //single
  const onChangeSingle = (e: RadioChangeEvent) => {
    const val = e.target.value;
    setSingle(val);
    setParam({
      ...param,
      orderByField: 'taskTotalCost',
      orderByValue: val ? 'asc' : 'desc'
    });
    getDatas({
      // 搜索框内容全部删除时，重置table数据
      orderByField: 'taskTotalCost',
      orderByValue: val ? 'asc' : 'desc'
    });
    getSlaOpenStatistics({
      orderByField: 'taskTotalCost',
      orderByValue: val ? 'asc' : 'desc'
    });
  };

  // 当页码等相关参数的改变时，重新加载数据
  useEffect(() => {
    getDatas();
  }, [page, size]);

  useEffect(() => {
    init();
  }, []);

  const downoadAll = async () => {
    message.info('请稍等，正在导出文件');
    const res = await downoadRenderApi(param);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(new Blob([res!.data]));
    link.setAttribute('download', '渲染.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="sla-list-content">
      <div className="sla-list-search">
        <Space>
          <span>时间范围：</span>
          <DatePicker onChange={onChange1} showTime />
          <span>-</span>
          <DatePicker onChange={onChange2} showTime />
          <span>分辨率：</span>
          <Select
            mode="multiple"
            style={{ width: 160 }}
            placeholder="请选择分辨率"
            onChange={handleChange1}
            showArrow
            showSearch={false}
            options={resolutions}
          />
          <span>渲染状态：</span>
          <Select
            style={{ width: 160 }}
            placeholder="请选择渲染状态"
            onChange={handleChange2}
            showArrow
            showSearch={false}
            options={status}
          />

        </Space>
        <Space style={{ marginTop: '12px' }}>
          <span>模型id：</span>
          <Input
            style={{ width: 160 }}
            placeholder="请输入模型id"
            onChange={handleModelIdChange}
            allowClear
            value={modelId}
          />
          <span>方案名称：</span>
          <Input
            style={{ width: 160 }}
            placeholder="请输入方案名称"
            onChange={handleItemNameChange}
            allowClear
            value={itemName}
          />
          <span>方案id：</span>
          <Input
            style={{ width: 160 }}
            placeholder="请输入方案id"
            onChange={handleItemIdChange}
            allowClear
            value={itemId}
          />
          <Radio.Group onChange={onChangeSingle} value={single}>
            <Radio value={true}>任务总耗时升序</Radio>
            <Radio value={false}>任务总耗时降序</Radio>
          </Radio.Group>
          <Button type="primary" ghost onClick={onSearch}>
            查询
          </Button>
          <Button onClick={downoadAll}>下载</Button>
        </Space>
        <Alert
          message={
            <>
              <div>
                渲染统计，平均耗时：{fileInfo?.totalAvgCost || 0}秒，最短耗时：
                {fileInfo?.totalMinCost || 0}秒，最长耗时：{fileInfo?.totalMaxCost || 0}秒
              </div>
              <div>
                失败总数：{fileInfo?.failedCnt}，总数：{fileInfo?.totalRecord}，失败占比：
                {fileInfo?.failedRatio}
              </div>
            </>
          }
          type="info"
          style={{ padding: '4px 15px', marginTop: '12px' }}
        />
      </div>

      <div className="sla-list-table">
        <ConfigProvider renderEmpty={renderEmpty}>
          <Table
            rowKey={(record) => record.id}
            loading={isLoading}
            columns={columns}
            dataSource={data || []}
            // pagination={false}
            pagination={{
              position: ['bottomRight'],
              size: 'small',
              showTotal: (total, range) => {
                return `${range[0]}-${range[1]}条，共${total}条`;
              },
              showTitle: true,
              showQuickJumper: false,
              showSizeChanger: true,
              total: total, // 分页总数
              pageSize: size, // 每页数量
              current: page, // 当前页数
              onChange: (p, s) => {
                console.log('翻页', { p, s });
                setPage(p);
                setSize(s as number);
              },
            }}
            scroll={{ x: true, y: 'calc(100vh - 345px)' }}
          />
        </ConfigProvider>
      </div>
    </div>
  );
};

export default Render;
